import { createStyles, makeStyles, Theme } from '@material-ui/core';


const MediaPreviewStyles = makeStyles(({ palette }: Theme) => createStyles({
  closeButton: {
    color: '#FFF',
    textTransform: 'unset',
    fontSize: 16,
    minWidth: 36,
    '&:hover': {
      background: 'rgba(255,255,255,0.15)',
    },
  },
}), { name: 'RecordPreviewAction' });

export default MediaPreviewStyles;
